import { cn } from "@/lib/utils"

import { RulePopover } from "./rule-popover"

interface SkillBadgeProps {
  name: string
  variant?: "default" | "starting" | "earned"
  className?: string
  style?: React.CSSProperties
}

const baseClasses =
  "text-[10px] font-bold uppercase tracking-[0.04em] px-1.5 py-px bg-muted text-foreground border border-border"

const variantClasses: Record<string, string> = {
  default: baseClasses,
  starting: `${baseClasses} opacity-70`,
  earned: `${baseClasses} bg-[oklch(0.25_0.08_85_/_0.3)] text-accent border-[oklch(0.45_0.1_85)]`,
}

export function SkillBadge({
  name,
  variant = "default",
  className,
  style,
}: SkillBadgeProps) {
  return (
    <RulePopover category="skill" ruleKey={name}>
      <span
        className={cn(variantClasses[variant], "cursor-pointer", className)}
        style={style}
      >
        {name}
      </span>
    </RulePopover>
  )
}
